<template>
  <div>
    <ActitiveTabcomponent :tabs="tabItems" :defaultTab="activeTab" @tab-changed="handleTabChange">
      <template #tab-buttons="{ activeTab }">
        <div class="flex items-center space-x-2">
          <template v-if="activeTab === 'products'">
            <v-text-field
              v-model="filterProduct"
              label="Search Products"
              solo
              flat
              clearable
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              class="filter-column"
            ></v-text-field>
            <v-btn color="primary" @click="toggleAddProduct" class="mr-2">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <template v-if="activeTab === 'allotments'">
            <v-select
              v-model="filterLocation"
              :items="branches"
              item-text="branchName"
              item-value="_id"
              label="Select Location"
              solo
              flat
              clearable
              outlined
              dense
              hide-details
              class="filter-column"
            ></v-select>
            <v-text-field
              v-model="filterAllotment"
              label="Search Product"
              solo
              flat
              clearable
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              class="filter-column"
            ></v-text-field>
            <v-btn color="primary" @click="toggleAddAllotment" class="mr-2">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>

          <template v-if="activeTab === 'history'">
            <v-select
              v-model="filterLocation"
              :items="branches"
              item-text="branchName"
              item-value="_id"
              label="Select Location"
              solo
              flat
              clearable
              outlined
              dense
              hide-details
              class="filter-column"
            ></v-select>
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  label="Date Range"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  solo
                  flat
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  class="filter-column"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" no-title range scrollable @input="onDateSelected">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="dateMenu = false">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </template>
        </div>
      </template>

      <!-- Tab Content Slots -->
      <template v-for="tab in tabItems" v-slot:[tab.key]="">
        <div v-if="!isLoad" :key="tab.key">
          <v-main class="bg-white" style="padding: 0px">
            <component
              :is="tab.component"
              :ref="tab.key"
              :search="activeTab === 'products' ? filterProduct : filterAllotment"
              :locationId="filterLocation"
              :startDate="startDate"
              :endDate="endDate"
              :productOptions="products"
              :branchOptions="branches"
              @refresh="fetchSharedData"
            />
          </v-main>
        </div>
        <div
          v-else
          :key="'load-' + tab.key"
          class="absolute w-full h-screen flex-col items-center flex justify-center"
        >
          <v-progress-circular
            :color="$vuetify.theme.currentTheme.primary"
            indeterminate
            :size="50"
            :width="5"
          ></v-progress-circular>
          <div class="mt-2"><span>Please Wait...</span></div>
        </div>
      </template>
    </ActitiveTabcomponent>
  </div>
</template>

<script>
import ProductsTab from '@/components/Workforce/ProductAllotment/ProductsTab.vue'
import AllotmentsTab from '@/components/Workforce/ProductAllotment/AllotmentsTab.vue'
import HistoryTab from '@/components/Workforce/ProductAllotment/HistoryTab.vue'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'

export default {
  name: 'ProductAllotmentPage',
  components: {
    ProductsTab,
    AllotmentsTab,
    HistoryTab,
    ActitiveTabcomponent
  },
  data() {
    return {
      isLoad: true,
      filterProduct: '',
      filterAllotment: '',
      filterLocation: null,
      dates: [],
      dateMenu: false,
      tabItems: [
        {
          key: 'products',
          label: 'Available Stocks',
          icon: 'mdi-package-variant',
          component: 'ProductsTab'
        },
        {
          key: 'allotments',
          label: 'Staff Allocations',
          icon: 'mdi-clipboard-list-outline',
          component: 'AllotmentsTab'
        },
        {
          key: 'history',
          label: 'Distribution Log',
          icon: 'mdi-history',
          component: 'HistoryTab'
        }
      ],
      products: [],
      branches: []
    }
  },
  computed: {
    activeTab() {
      return this.$route.query.activeTab || 'products'
    },
    startDate() {
      return this.dates[0] || null
    },
    endDate() {
      return this.dates[1] || null
    },
    formattedDate() {
      if (this.dates.length === 2) {
        return `${this.$dayjs(this.dates[0]).format('DD/MM/YYYY')} - ${this.$dayjs(
          this.dates[1]
        ).format('DD/MM/YYYY')}`
      }
      return this.dates[0] ? this.$dayjs(this.dates[0]).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        // Reset filters when switching tabs if needed, but the user didn't ask for that.
        // We'll keep them as they might want to see same location across tabs.
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },
    onDateSelected() {
      if (this.dates.length === 2) {
        this.dateMenu = false
      }
    },
    async fetchSharedData() {
      try {
        const [prodRes, branchRes] = await Promise.all([
          this.$axios.get('/inventory/products'),
          this.$axios.get('/branches')
        ])
        this.products = prodRes.data?.products || []
        this.branches = branchRes.data?.branches || []
      } catch (e) {
        console.error('Error fetching shared inventory data', e)
      }
    },
    toggleAddProduct() {
      if (this.$refs.products && this.$refs.products[0]) {
        this.$refs.products[0].openDialog(null)
      }
    },
    toggleAddAllotment() {
      if (this.$refs.allotments && this.$refs.allotments[0]) {
        this.$refs.allotments[0].openDialog(null)
      }
    }
  },
  mounted() {
    if (!this.$route.query.activeTab) {
      this.$router.replace({
        query: { ...this.$route.query, activeTab: 'products' }
      })
    }

    this.fetchSharedData()

    this.$nextTick(() => {
      this.isLoad = false
    })
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
  font-size: var(--font-normal);
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.filter-column {
  width: 300px;
}
</style>
